'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCut = function FaCut(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.4 20q0.6 0 1 0.4t0.5 1-0.5 1-1 0.5-1-0.5-0.4-1 0.4-1 1-0.4z m6.7 1.4l11.3 8.9q0.7 0.5 0.6 1.3-0.1 0.7-0.8 1.1l-2.8 1.4q-0.3 0.2-0.7 0.2-0.4 0-0.7-0.2l-15.4-8.6-2.4 1.4q-0.2 0.1-0.3 0.2 0.3 1 0.2 2.1-0.1 1.7-1.2 3.3t-3 2.8q-2.9 1.8-6.2 1.8-3 0-4.9-1.7-2-1.9-1.8-4.6 0.2-1.7 1.3-3.3t2.9-2.8q2.9-1.8 6.2-1.8 1.9 0 3.4 0.6 0.2-0.2 0.5-0.4l2.7-1.7-2.7-1.6q-0.3-0.2-0.5-0.5-1.5 0.7-3.4 0.7-3.3 0-6.2-1.9-1.8-1.2-2.9-2.7t-1.3-3.3q-0.1-1.3 0.4-2.5t1.4-2.1q1.9-1.8 4.9-1.8 3.3 0 6.2 1.9 1.9 1.2 3 2.7t1.2 3.3q0.1 1.1-0.2 2.2 0.1 0 0.3 0.1l2.4 1.5 15.4-8.6q0.3-0.2 0.7-0.2 0.4 0 0.7 0.1l2.8 1.5q0.7 0.3 0.8 1.1 0.1 0.8-0.6 1.3z m-15.2-5.8q1.1-0.9 0.5-2.4t-2.4-2.6q-2-1.3-4.3-1.3-1.6 0-2.5 0.8-1 0.9-0.4 2.4t2.3 2.6q2.1 1.3 4.3 1.3 1.7 0 2.5-0.8z m-1.9 16.7q1.8-1.2 2.4-2.7t-0.5-2.4q-0.8-0.8-2.5-0.8-2.2 0-4.3 1.3-1.8 1.2-2.3 2.7t0.4 2.4q0.9 0.8 2.5 0.8 2.3 0 4.3-1.3z m4-13.7l2.1 1.3v-0.3q0-0.8 0.8-1.2l0.3-0.2-1.8-1.1-0.6 0.6q0 0.1-0.2 0.3t-0.2 0.2q-0.1 0.1-0.1 0.1t-0.1 0.1z m5 5l2.1 0.7 16.5-12.9-2.9-1.4-17.1 9.6v2.5l-3.6 2.2 0.2 0.2q0 0 0.2 0.1 0 0.1 0.2 0.3t0.3 0.2l0.5 0.6z m15.7 9.3l2.9-1.5-11.6-9.1-4 3.1q0 0.1-0.3 0.2z' })
        )
    );
};

exports.default = FaCut;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/cut.js
// module id = 1318
// module chunks = 0